import { gql } from '@apollo/client';

export const STATS_QUERY = gql`
    query stats {
        stats {
            companyId
            users
            totalUsers
            learningObjects {
                active
                inactive
                total
            }
            courses {
                active
                inactive
                total
            }
            curricula {
                total
            }
            assets {
                total
            }
            enrollments {
              assigned
              inProgress
              completed
              total
            }
            assignments {
              assigned
              inProgress
              completed
              total
            }
        }
    }
`;
